import { useCheckoutStore } from "@/lib/store/checkout";
import { type AddressApi, AddressCodec } from "../paycode/address";
import { type CardApi, CardCodec } from "../paycode/card";
import {
  type DynamicFieldApi,
  DynamicFieldCodec,
} from "../paycode/dynamic-field";
import { type ProductApi, ProductCodec } from "../paycode/product";
import {
  type BrowserDataApi,
  getBrowserData,
  serializeBrowserData,
} from "./browser-data";
import { type Customer, serializeCustomer } from "./customer";

export interface PaymentApi {
  hash: string;
  payment_amount: string;
  products: ProductApi[];
  info?: CardApi;
  numero_tel?: string;
  paycips?: boolean;
  customer_information?: Customer;
  dinamic_fields: DynamicFieldApi[];
  shipping_address?: AddressApi;
  billing_address?: AddressApi;
  browser?: BrowserDataApi;
  clear_sale?: {
    session_id: string;
  };
}

export const serializePayment = (): PaymentApi => {
  const browserData = getBrowserData();
  const {
    hash,
    products,
    dynamicFields,
    total,
    card,
    client,
    shippingAddress,
    billingAddress,
  } = useCheckoutStore.getState();

  return {
    hash,
    payment_amount: total.toFixed(2),
    products: products.map(ProductCodec.encode),
    dinamic_fields: dynamicFields?.map(DynamicFieldCodec.encode) || [],
    info: card ? CardCodec.encode(card) : undefined,
    paycips: card ? false : undefined,
    numero_tel: card ? "" : undefined,
    customer_information: client ? serializeCustomer(client) : undefined,
    shipping_address: shippingAddress
      ? AddressCodec.encode(shippingAddress)
      : undefined,
    billing_address: billingAddress
      ? AddressCodec.encode(billingAddress)
      : undefined,
    browser: serializeBrowserData(browserData),
    clear_sale: browserData?.clearSaleSession
      ? { session_id: browserData.clearSaleSession }
      : undefined,
  };
};
